import { Chip } from "@/components/chip/chip.component";

import { ProductTileProduct } from "./productTile.component";
import { Chip as ProductChip, Theme } from "@/sanity.types";

export const ProductTileOverlayChips = ({
  product,
  pageType = "",
}: ProductTileOverlayChipsProps) => {
  if (!product.promotion?.chips?.length && !product.chips?.length) {
    return null;
  }

  const isChipAllowed = (chip: ProductChip) => {
    const hiddenPages = chip?.hiddenPages || [];
    if (hiddenPages.includes(pageType)) return false;
    return true;
  };

  const renderChips = (
    chips?: ProductChip[] | null | undefined,
    variant: Theme = "secondary",
  ) => {
    if (!chips?.length) return null;
    return chips?.map((tag: ProductChip, index) => {
      if (!isChipAllowed(tag)) return null;

      const chipVariant = tag?.theme ?? variant;

      return (
        <Chip key={index} label={tag.label} variant={chipVariant} chip={tag} />
      );
    });
  };
  return (
    <div
      className="absolute top-4 left-4 z-10 flex flex-row flex-wrap gap-2 md:[&>:not(:first-child)]:flex"
      data-testid="product-tile-badges">
      {renderChips(product.promotion?.chips, "promo")}
      {renderChips(product.chips)}
    </div>
  );
};

export type ProductTileOverlayChipsProps = {
  product: ProductTileProduct;
  pageType?: string;
};
